if (!window.GIFT_VARIANT_ID) window.GIFT_VARIANT_ID = 49521187422551;
if (!window.PRIORITY_VARIANT_ID) window.PRIORITY_VARIANT_ID = 50166180086103;
// Beispiel: neue ID registrieren
if (!window.NEW_TOGGLE_VARIANT_ID) window.NEW_TOGGLE_VARIANT_ID = 49574705430871;


document.addEventListener("DOMContentLoaded", () => {
  bindToggle('gift-toggle', window.GIFT_VARIANT_ID);
  bindToggle('priority-toggle', window.PRIORITY_VARIANT_ID);
    bindToggle('new-toggle', window.NEW_TOGGLE_VARIANT_ID);

  setupToggleObserver();
});

async function bindToggle(toggleId, variantId) {
  const toggle = document.getElementById(toggleId);
  if (!toggle || toggle.dataset.bound === 'true') return;

  toggle.dataset.bound = 'true';
  toggle.disabled = true;

  try {
    const cart = await fetch('/cart.js').then(r => r.json());
    const isInCart = cart.items.some(i => i.variant_id === variantId);
    toggle.checked = isInCart;
  } catch (err) {}

  toggle.disabled = false;

  toggle.addEventListener('change', async (e) => {
    toggle.disabled = true;
    try {
      const cart = await fetch('/cart.js').then(r => r.json());

      if (e.target.checked) {
        // Füge Priority hinzu
        const itemsToAdd = [{ id: variantId, quantity: 1 }];

        // Falls Priority-Toggle aktiv → auch Mystery-Probe hinzufügen
// if (toggleId === 'priority-toggle') {
//   itemsToAdd.push({ id: window.NEW_TOGGLE_VARIANT_ID, quantity: 1 });
// }

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        });

      } else {
        // Entferne Priority
        const priorityItem = cart.items.find(i => i.variant_id === variantId);
        if (priorityItem) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: priorityItem.key, quantity: 0 })
          });
        }

      // Falls Priority-Toggle → auch Mystery-Probe entfernen
// if (toggleId === 'priority-toggle') {
//   const updatedCart = await fetch('/cart.js').then(r => r.json());
//   const mysteryItem = updatedCart.items.find(i => i.variant_id === window.NEW_TOGGLE_VARIANT_ID);
//   if (mysteryItem) {
//     await fetch('/cart/change.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ id: mysteryItem.key, quantity: 0 })
//     });
//   }
// }


      }

      await refreshCart();
    } catch (err) {}

    toggle.disabled = false;
  });
}



async function refreshCart() {
  const res = await fetch('/cart.js');
  const cart = await res.json();
  await reloadDrawer();
  document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

  const totalElem = document.querySelector('[data-hulkapps-cart-total]');
  if (totalElem) {
    totalElem.textContent = (cart.total_price / 100).toFixed(2).replace('.', ',') + ' €';
  }
}

async function reloadDrawer() {
  try {
    const res = await fetch('/?sections=cart-drawer');
    const html = await res.json();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html['cart-drawer'], 'text/html');
    const newDrawer = doc.querySelector('#cart-drawer');
    const currentDrawer = document.querySelector('#cart-drawer');
    if (newDrawer && currentDrawer) {
      currentDrawer.innerHTML = newDrawer.innerHTML;
      const cart = await fetch('/cart.js').then(r => r.json());
      if (typeof window.updateCartProgressBar === 'function') {
        window.updateCartProgressBar(cart);
      }
    }
  } catch (err) {}
}

function setupToggleObserver() {
  const drawer = document.querySelector('#cart-drawer');
  if (!drawer) return;

  const observer = new MutationObserver(() => {
    ['gift-toggle', 'priority-toggle', 'new-toggle'].forEach(id => {
      const toggle = document.getElementById(id);
      if (toggle && toggle.dataset.bound !== 'true') {
        requestAnimationFrame(() => {
          let variantId;
          if (id === 'gift-toggle') variantId = window.GIFT_VARIANT_ID;
          else if (id === 'priority-toggle') variantId = window.PRIORITY_VARIANT_ID;
          else if (id === 'new-toggle') variantId = window.NEW_TOGGLE_VARIANT_ID;
          if (variantId) bindToggle(id, variantId);
        });
      }
    });
  });

  observer.observe(drawer, { childList: true, subtree: true });
}

